import { Box, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import SingleItem from "../LandingPageFeature/LandingPageFeature";
import secure from "../../../assets/staticAssets/01.svg";
import support from "../../../assets/staticAssets/02.svg";
import charges from "../../../assets/staticAssets/03.svg";
import { makeStyles } from "@material-ui/styles";
import TransparentFlexBox from "../TransparentFlexBox/TransparentFlexBox";
import EndCredits from "../EndCredits/EndCredits";
import earn from "../../../assets/staticAssets/earn_2.svg";
import googleplay from "../../../assets/staticAssets/googleplay.png";
import Img from "react-cool-img";

function LandingPageSixthSection() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const sm_matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <div className="pb-20  relative">
        <div className="container-bt relative">
          <div className="">
            <div className="leading-relaxed">
              <div className="justify-center items-start flex mb-10">
                <Img
                  className="mr-4"
                  src={
                    require("../../../assets/optimized/Landing/Highlights Section/check mark.svg")
                      .default
                  }
                />
                <h1 className="font-extrabold ">
                  Empowering Crypto Users in India Since 2017
                </h1>
              </div>
              <div className="flex justify-evenly md:justify-between gap-y-5 md:gap-y-0 flex-wrap md:flex-nowrap">
                <div className="flex flex-col items-center text-center">
                  <Img
                    style={{
                      height: "160px",
                      width: "160px",
                    }}
                    src={
                      require("../../../assets/optimized/Landing/Highlights Section/Happy Users-icon.svg")
                        .default
                    }
                  />
                  <h2>Happy Users</h2>
                  <p className="font-light" style={{ color: "#ccc" }}>
                    Best in Industry 24/7 <br></br>Customer Support
                  </p>
                </div>
                <div className="flex flex-col items-center text-center">
                  <Img
                    style={{
                      height: "160px",
                      width: "18160px0px",
                    }}
                    src={
                      require("../../../assets/optimized/Landing/Highlights Section/Trading volume-icon.svg")
                        .default
                    }
                  />
                  <h2>Trading volume</h2>{" "}
                  <p className="font-light" style={{ color: "#ccc" }}>
                    Infinite Liquidity to ensure<br></br> you never miss a trade
                  </p>
                </div>
                <div className="flex flex-col items-center text-center">
                  <Img
                    style={{
                      height: "160px",
                      width: "160px",
                    }}
                    src={
                      require("../../../assets/optimized/Landing/Highlights Section/Founded In-icon.svg")
                        .default
                    }
                  />
                  <h2>Founded in</h2>{" "}
                  <p className="font-light" style={{ color: "#ccc" }}>
                    Among India’s first<br></br> Crypto exchanges
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({}));

export default LandingPageSixthSection;
